import { Controller } from "stimulus";

export default class extends Controller {

  static targets = ["productsList", "completeOrderBtn"];

  connect() {

    var cartCheckboxes = this.element.querySelectorAll(".product-ready-checkbox");

    cartCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", (e) => {
        
        var selectedCheckBoxes = this.element.querySelectorAll(".product-ready-checkbox:checked");

        if (selectedCheckBoxes.length == cartCheckboxes.length) {
          this.completeOrderBtnTarget.click();
        }



      });
    });
  }

  toggleProductsList() {
    this.productsListTarget.classList.toggle("hidden");
  }



}